export default "__VITE_ASSET__CeqPpNiv__"